import { Component } from 'vue-property-decorator';
import BingoPrizeComponent from '@/components/game/implementations/_default/_components/prize';
import { IGameWonArgs } from '@/components/game/_domain/models';
import JackpotComponent from '@/components/game/implementations/_default/_components/jackpot';

@Component({
  name: 'Bingo75PrizeComponent',
  components: {
    jackpot: JackpotComponent
  }
})
export default class Bingo75PrizeComponent extends BingoPrizeComponent {
  protected handleGameWon(eventArgs: IGameWonArgs) {
    // we purposely don't want to update prize winners here
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/bingo-75/_components/prize/prize.component.ts